module.exports = __webpack_public_path__ + "img/tasantea_qr.b4121033.jpg";